import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import './ConsumableNavbar.scss';
import SortBy from 'components/SortBy/SortBy';


type Props = {
  title: string;
  option?: ReactElement
  consumableInput?: ReactElement
  showSortBy?: boolean
}
const ConsumableNavbar: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="consumable-navbar-container">
      <div className="breadcrumbs">
        {t(props.title)}
      </div>
      {props.showSortBy ? <SortBy /> : null}
      <div className="input">{props.consumableInput}</div>
      <div className="options">{props.option}</div>
    </div>
  );
};


export default ConsumableNavbar;